// Small helpers for the "create-and-return" flow: when a form page (e.g. New
// Case) needs a related record that doesn't exist yet (a new Client), it stashes
// its in-progress draft, navigates to the create page with a ?returnTo, and on
// return restores the draft and picks up the id of the just-created record.
//
// Uses sessionStorage so a full navigation (not just a modal) preserves state.

const DRAFT_PREFIX = 'draft:';
const CREATED_CLIENT_KEY = 'createdClientId';

export function saveDraft(key, data) {
  try {
    sessionStorage.setItem(DRAFT_PREFIX + key, JSON.stringify(data));
  } catch {
    /* storage full / unavailable — the draft just won't persist */
  }
}

// Read and remove a draft in one call (drafts are single-use on return).
export function takeDraft(key) {
  try {
    const raw = sessionStorage.getItem(DRAFT_PREFIX + key);
    if (raw == null) return null;
    sessionStorage.removeItem(DRAFT_PREFIX + key);
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function setCreatedClientId(id) {
  try {
    sessionStorage.setItem(CREATED_CLIENT_KEY, id);
  } catch {
    /* ignore */
  }
}

export function takeCreatedClientId() {
  try {
    const id = sessionStorage.getItem(CREATED_CLIENT_KEY);
    if (id) sessionStorage.removeItem(CREATED_CLIENT_KEY);
    return id || null;
  } catch {
    return null;
  }
}
